import { render, staticRenderFns } from "./NuevaLiquidacion.vue?vue&type=template&id=1127a0f6&scoped=true"
import script from "./NuevaLiquidacion.vue?vue&type=script&lang=js"
export * from "./NuevaLiquidacion.vue?vue&type=script&lang=js"
import style0 from "./NuevaLiquidacion.vue?vue&type=style&index=0&id=1127a0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127a0f6",
  null
  
)

export default component.exports